import { Tooltip } from "@octopusdeploy/design-system-components";
import type { LiveStatusSummaryResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink";
import DateFormatter from "~/utils/DateFormatter";
import { LiveStatusIcon } from "../../../Observability/LiveStatusIcon";
import { deploymentTitle, statusColumn, statusIcon, liveStatusRow, deploymentStatus, liveStatusTimestamp } from "./styles";
interface LiveStatusRowProps {
    spaceId: string;
    projectId: string;
    environmentId: string;
    tenantId?: string;
    summary: LiveStatusSummaryResource;
}
export const LiveStatusRow = (props: LiveStatusRowProps) => {
    const { spaceId, projectId, environmentId, tenantId, summary } = props;
    const getTitle = () => {
        const content = (<Tooltip content={DateFormatter.dateToShortFormat(summary.LastUpdated)} position="top">
                <span className={deploymentTitle}>Live Status</span>
            </Tooltip>);
        const pageUrl = tenantId === undefined
            ? links.untenantedApplicationLiveStatusPage.generateUrl({ spaceId: spaceId, projectSlug: projectId, environmentId: environmentId })
            : links.tenantedApplicationLiveStatusPage.generateUrl({ spaceId: spaceId, projectSlug: projectId, environmentId: environmentId, tenantId: tenantId });
        return <InternalLink to={pageUrl}>{content}</InternalLink>;
    };
    return (<div className={liveStatusRow}>
            <div className={liveStatusTimestamp}>
                <div>Last Updated</div>
                <div>{DateFormatter.momentAgo(summary.LastUpdated.toString())}</div>
            </div>
            <div className={statusIcon}>
                <LiveStatusIcon status={summary.Status} size={28}/>
            </div>
            <div className={statusColumn}>
                {getTitle()}
                <div className={deploymentStatus}>
                    <em className="fa-solid fa-bolt" style={{ marginRight: "4px" }}/> {summary.Status}
                </div>
            </div>
        </div>);
};
